import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/hooks/useLanguage";
import Index from "./pages/Index";
import About from "./pages/About";
import Procurement from "./pages/Procurement";
import Careers from "./pages/Careers";
import Pillars from "./pages/Pillars";
import Homes from "./pages/Homes";
import Hotels from "./pages/Hotels";
import Developments from "./pages/Developments";
import Technologies from "./pages/Technologies";
import FAQ from "./pages/FAQ";
import NewsPress from "./pages/NewsPress";
import ContactPage from "./pages/Contact";
import BlogPost from "./pages/BlogPost";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <LanguageProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/procurement" element={<Procurement />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/pillars" element={<Pillars />} />
            <Route path="/portfolio/homes" element={<Homes />} />
            <Route path="/portfolio/hotels" element={<Hotels />} />
            <Route path="/portfolio/developments" element={<Developments />} />
            <Route path="/portfolio/technologies" element={<Technologies />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/news-press" element={<NewsPress />} />
            <Route path="/blog/:id" element={<BlogPost />} />
            <Route path="/news/:id" element={<BlogPost />} />
            <Route path="/press/:id" element={<BlogPost />} />
            <Route path="/contact" element={<ContactPage />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </LanguageProvider>
  </QueryClientProvider>
);

export default App;
